import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import store from '@/store';
import Card from '@/components/layout/Card.vue';
import { SettingChangeParams } from '@/store/models/settings';
import { SETTING_CHANGE } from '@/store/actions/platforms';
var SettingItem = /*#__PURE__*/function (_Vue) {
  function SettingItem() {
    var _this;
    _classCallCheck(this, SettingItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SettingItem, [].concat(args));
    _defineProperty(_this, "keyValue", void 0);
    _defineProperty(_this, "platform", void 0);
    _defineProperty(_this, "label", void 0);
    _defineProperty(_this, "disabled", void 0);
    _defineProperty(_this, "icon", void 0);
    _defineProperty(_this, "tooltip", void 0);
    _defineProperty(_this, "value", false);
    _defineProperty(_this, "errorMsg", '');
    return _this;
  }
  _inherits(SettingItem, _Vue);
  return _createClass(SettingItem, [{
    key: "settingValue",
    get: function get() {
      if (this.setting === undefined) {
        return false;
      } else {
        var value = this.setting[this.keyValue];
        return value;
      }
    }
  }, {
    key: "setting",
    get: function get() {
      return store.getters.settings(this.platform.platformID);
    }
  }, {
    key: "settingChange",
    value: function settingChange(event) {
      this.value = this.setting[this.keyValue];
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.value = this.settingValue;
    }
  }, {
    key: "changeValue",
    value: function changeValue() {
      var _this2 = this;
      var params = new SettingChangeParams(this.platform.platformID, this.keyValue, this.value);
      store.dispatch(SETTING_CHANGE, params).then(function () {
        _this2.errorMsg = '';
      }).catch(function (err) {
        _this2.errorMsg = err;
      });
    }
  }]);
}(Vue);
__decorate([Prop()], SettingItem.prototype, "keyValue", void 0);
__decorate([Prop()], SettingItem.prototype, "platform", void 0);
__decorate([Prop({
  default: ''
})], SettingItem.prototype, "label", void 0);
__decorate([Prop({
  default: false
})], SettingItem.prototype, "disabled", void 0);
__decorate([Prop({
  default: ''
})], SettingItem.prototype, "icon", void 0);
__decorate([Prop({
  default: ''
})], SettingItem.prototype, "tooltip", void 0);
__decorate([Watch('setting', {
  immediate: true,
  deep: true
})], SettingItem.prototype, "settingChange", null);
SettingItem = __decorate([Options({
  components: {
    Card: Card
  }
})], SettingItem);
export default SettingItem;